import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';
import { saveNavigationRoute } from '../../../actions/actions';
import { IUserData } from '../../../infrastructure/interfaces';

export interface IProtectedRouteProps extends RouteProps {
  user?: IUserData;
  path: string;
  component: any;
  saveNavigationRoute(navigationRoute: string): void;
}

const mapDispatchToProps = (dispatch: any): any => {
  return {
    saveNavigationRoute: (navigationRoute: string) => {
      dispatch(saveNavigationRoute(navigationRoute));
    }
  };
};

const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    user: state.user.data
  };
};

@(connect(mapStateToProps, mapDispatchToProps) as any)
export default class ProtectedRoute extends React.Component<IProtectedRouteProps>{

  render() {
    const {
      user,
      component: Component,
      path,
      ...rest
    } = this.props;

    this.props.saveNavigationRoute(this.props.path);

    return (
      <Route {...rest} render={(props) => {
        return user
          ? <Component />
          : <Redirect to="/Login" />;
      }} />);
  }
}




// WEBPACK FOOTER //
// ./src/components/App/components/ProtectedRouter.tsx